import { ReactNode } from 'react';
import styles from './ActionBar.module.scss';

const ActionBar = ({ children }: { children: ReactNode }) => (
  <div className={styles.root}>{children}</div>
);

export default ActionBar;
